/**
 * `aria-describedby` for fields: validation error **or** hint, never both (duplicate SR speech).
 * Use `also` for ids that apply in every state (e.g. character count).
 */
export function fieldDescribedByIds(options: {
    errorId: string;
    hasError: boolean;
    hintId?: string;
    also?: string[];
}): string | undefined {
    const { errorId, hasError, hintId, also = [] } = options;
    const ids = (hasError ? [errorId, ...also] : [hintId, ...also]).filter((id): id is string => Boolean(id));
    return ids.length > 0 ? ids.join(' ') : undefined;
}
